var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line",style:({ height: _vm.lineStyle.height, width: _vm.lineStyle.width }),attrs:{"id":_vm.Line}})}
var staticRenderFns = []

export { render, staticRenderFns }